import React from "react";
import { Bar } from "react-chartjs-2";

const BlockedWorkChart = () => {

  const data = {
    labels:["Dependency","Infrastructure","Testing","External"],
    datasets:[
      {
        label:"Blocked Tasks",
        data:[5,2,4,3],
        backgroundColor:"#ef4444"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl">
      <h3 className="text-white mb-4">🚫 Blocked Work</h3>
      <Bar data={data}/>
    </div>
  );
};

export default BlockedWorkChart;